import { DomSanitizer } from '@angular/platform-browser';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { NavigatorService } from '../services/navigator/navigator.service';

const { marked } = require('marked');

@Pipe({
  name: 'mdToHtml',
})
export class MdToHtmlPipe implements PipeTransform {
  private isApp: boolean = inject(NavigatorService).isApp;

  constructor(private _sanitizer: DomSanitizer) {}

  original!: string;

  transform(v: string): any {
    const renderer = new marked.Renderer();

    renderer.link = (href: string, title: string, text: string): string => {
      const link = this.isApp ? `external-${href}` : href;
      return `<a href="${link}">${text}</a>`;
    };

    marked.use({ renderer });

    const markedParser = marked.setOptions([]);
    this.original = v ? markedParser.parse(v) : '';
    return this._sanitizer.bypassSecurityTrustHtml(this.original);
  }
}
